
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data=null) {
        const clean = {};
        if (data) {
            Object.keys(data).forEach((key) => {
                const val = data[key];
                if (val !== null && val !== undefined && val !== '') {
                    clean[key] = val;
                }
            });
        }
        const queryString = new URLSearchParams(clean).toString();
        const url = `${API_URL}/remissions?${queryString}`; 

        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/remissions/${id}`, { headers: authHeader() });
    },
    createData(data) {
        const loggedUser = JSON.parse(localStorage.getItem('user'));
        if (!loggedUser || !loggedUser.id) {
            throw new Error('User ID no válido. Asegúrate de haber iniciado sesión.');
        }

        const clientId = Number(data.client_id ?? data.user_id ?? 0);
        if (!clientId) {
            throw new Error('Debe seleccionar un cliente.');
        }

        const payload = {
            ...data,
            user_id: clientId,
            seller_id: loggedUser.id,
        };
        delete payload.client_id;

        return axios.post(`${API_URL}/remissions`, payload, { headers: authHeader() });
    },
    updateData(id, data) {
        const payload = { ...data };
        const clientId = Number(
            payload.client_id !== undefined && payload.client_id !== null && payload.client_id !== ''
                ? payload.client_id
                : payload.user_id ?? 0
        );
        if (clientId) {
            payload.user_id = clientId;
        }
        delete payload.client_id;

        // No enviar seller_id al editar: el asesor se asigna al crear la remisión
        // y no debe cambiar aunque otro usuario la modifique.
        delete payload.seller_id;

        return axios.put(`${API_URL}/remissions/${id}`, payload, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/remissions/${id}`, { headers: authHeader() });
    },
    getDoc(id) {
        return axios.get(`${API_URL}/remissions/export/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getPdf(id) {
        return axios.get(`${API_URL}/remissions/export-pdf/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getNote(id) {
        return axios.get(`${API_URL}/remissions/export-note/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getNoStockNote(id) {
        return axios.get(`${API_URL}/remissions/export-no-stock-note/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getNoStockNoteGrouped(id) {
        return axios.get(`${API_URL}/remissions/export-no-stock-note-grouped/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getPendingItems(ids = []) {
        const query = ids.length ? `?ids[]=${ids.join('&ids[]=')}` : '';
        return axios.get(`${API_URL}/remissions/export-pending-items${query}`, { headers: authHeader(), responseType: 'blob' });
    },
    getPendingItemsGrouped(ids = []) {
        const query = ids.length ? `?ids[]=${ids.join('&ids[]=')}` : '';
        return axios.get(`${API_URL}/remissions/export-pending-items-grouped${query}`, { headers: authHeader(), responseType: 'blob' });
    },
    getPendingOrders(ids = []) {
        const query = ids.length ? `?ids[]=${ids.join('&ids[]=')}` : '';
        return axios.get(`${API_URL}/remissions/export-pending-orders${query}`, { headers: authHeader(), responseType: 'blob' });
    },
    getDispatchRelation(ids = []) {
        const query = ids.length ? `?ids[]=${ids.join('&ids[]=')}` : '';
        return axios.get(`${API_URL}/remissions/export-dispatch-relation${query}`, { headers: authHeader(), responseType: 'blob' });
    },
    formalize(id) {
        return axios.post(`${API_URL}/remissions/${id}/formalize`, {}, { headers: authHeader() });
    },
    syncToShopify(id) {
        return axios.post(`${API_URL}/shopify/remissions/${id}/sync`, {}, { headers: authHeader() });
    },
    markPrepared(id, barcode) {
        return axios.post(`${API_URL}/remissions/${id}/mark-prepared`, { barcode }, { headers: authHeader() });
    },
    markPreparedById(detailId) {
        return axios.post(`${API_URL}/remission-details/${detailId}/mark-prepared`, {}, { headers: authHeader() });
    },
    updatePreparado(id, preparado) {
        return axios.put(`${API_URL}/remissions/${id}/preparado`, { preparado }, { headers: authHeader() });
    },
    updateSentToProduction(id, sentToProduction) {
        return axios.put(`${API_URL}/remissions/${id}/sent-to-production`, { sent_to_production: sentToProduction }, { headers: authHeader() });
    },
    markBarcodeGenerated(ids = []) {
        return axios.post(`${API_URL}/remissions/mark-barcode-generated`, { ids }, { headers: authHeader() });
    },
    findByBarcode(barcode) {
        return axios.get(`${API_URL}/remissions/find-by-barcode`, { params: { barcode }, headers: authHeader() });
    },
};
